module.exports = {"411121100":"舞泉镇","411121101":"吴城镇","411121102":"北舞渡镇","411121103":"莲花镇","411121104":"辛安镇","411121105":"孟寨镇","411121106":"太尉镇","411121107":"侯集镇","411121108":"九街镇","411121109":"章化镇","411121200":"文峰乡","411121201":"保和乡","411121202":"马村乡","411121204":"姜店乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411121.json
// module id = 1627
// module chunks = 0